import { forwardRef } from "react";

import { clsx } from "clsx";

import type { HTMLAttributes } from "react";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={clsx(
      `p-6 rounded-lg border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800`,
      className,
    )}
    {...props}
  >
    {children}
  </div>
));

Card.displayName = `Card`;

interface CardHeaderProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const CardHeader = forwardRef<HTMLDivElement, CardHeaderProps>(({ className, children, ...props }, ref) => (
  <div ref={ref} className={clsx(`flex flex-col space-y-1.5 pb-6`, className)} {...props}>
    {children}
  </div>
));

CardHeader.displayName = `CardHeader`;

interface CardTitleProps extends HTMLAttributes<HTMLHeadingElement> {
  children: React.ReactNode;
}

export const CardTitle = forwardRef<HTMLHeadingElement, CardTitleProps>(({ className, children, ...props }, ref) => (
  <h3 ref={ref} className={clsx(`text-2xl font-semibold leading-none tracking-tight`, className)} {...props}>
    {children}
  </h3>
));

CardTitle.displayName = `CardTitle`;

interface CardDescriptionProps extends HTMLAttributes<HTMLParagraphElement> {
  children: React.ReactNode;
}

export const CardDescription = forwardRef<HTMLParagraphElement, CardDescriptionProps>(
  ({ className, children, ...props }, ref) => (
    <p ref={ref} className={clsx(`text-sm text-muted-foreground`, className)} {...props}>
      {children}
    </p>
  ),
);

CardDescription.displayName = `CardDescription`;

interface CardContentProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const CardContent = forwardRef<HTMLDivElement, CardContentProps>(({ className, children, ...props }, ref) => (
  <div ref={ref} className={clsx(`pt-0`, className)} {...props}>
    {children}
  </div>
));

CardContent.displayName = `CardContent`;
